import includedUser from './includes/user';

const attachment = (attachmentJson) => {
  const properties = {
    ...attachmentJson.attributes,
    creator: includedUser(attachmentJson.attributes.creator),
    guid: attachmentJson.guid,
  };
  return properties;
};

export default attachment;
